export var fetchTenantCulture = async function fetchTenantCulture(host, tenant) {
  var hostWithSlash = host.endsWith('/') ? host : host + "/";
  var response = await fetch(hostWithSlash + "tenants/" + tenant + "/culture");

  if (response.status !== 200) {
    return undefined;
  }

  try {
    var data = await response.json();
    return data;
  } catch (error) {
    console.error('Could not fetch TenantCulture from API');
    return undefined;
  }
};